import Endpoints from "../constants/Endpoints";
import {RestRequestGET, RestRequestPOST} from "../libs/RestRequest";
import isResponseValid from "../libs/isResponseValid";
import reduxStore from "../redux/store";
import {setSaveStatusError} from "../redux/actions";
import Tr from "../translations/Translations";

const showError = (message) => {
    reduxStore.dispatch(setSaveStatusError(message))
}

const getCases = async (demandId) => {
    try {
        const resp = await RestRequestGET(Endpoints.EZDPUW(demandId));
        if (isResponseValid(resp, showError)) {
            return resp.result;
        }
    } catch (e) {
        console.error(e);
        showError(Tr('internal_server_error'));
    }
    throw new Error();
}
const getDocuments = async (demandId, caseId) => {
    try {
        const resp = await RestRequestGET(Endpoints.EZDPUW_DOCUMENTS(demandId, caseId));
        if (isResponseValid(resp, showError)) {
            return resp.result;
        }
    } catch (e) {
        console.error(e);
        showError(Tr('internal_server_error'));
    }
    throw new Error();
}

const downloadFileFromEzdpuw = async (demandId, file) => {
    try {
        return await RestRequestPOST(Endpoints.EZDPUW(demandId), file);
    } catch (e) {
        console.error(e);
    }
    return {uploadStatus: "ERROR"}
}

export default {
    getCases,
    getDocuments,
    downloadFileFromEzdpuw
};

